import { BaseStatGenerator } from './BaseStatsGenerator';
import PlayerStatModel from '../../../../Common/models/playerstat.model';
import AggregatedPlayerStatModel from '../../../../Common/models/aggregatedplayerstat.model';

export class HeraldKillsStatsGenerator extends BaseStatGenerator {
  getStatTitle(): string {
    return 'RHTPG';
  }

  getToolTip(): string {
    return 'Rift Herald Taken Per Game';
  }

  getStatValue(playerStatsModel: AggregatedPlayerStatModel): number {
    return playerStatsModel.riftHeraldTakedowns / playerStatsModel.games;
  }
}